import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type OrderBaseFragment = { id: string, pk: number, pubId: string, token: string, created: any, userEmail: string, status: Types.DeliveryGroupStatusEnum, isFullyPaid: boolean, isNotPaid: boolean, isShippingRequired: boolean, isDelivered: boolean, shippingMethodName: string | null, groupLastUpdated: any | null, userId: number | null, giftCardData: any, isGiftCard: boolean, shippingCustomDiscount: any, currency: string, checkoutRate: any, totalTax: { currency: string, gross: number } | null, shippingDiscountAmount: { currency: string, gross: number } };

export const OrderBaseFragmentDoc = gql`
    fragment OrderBaseFragment on OrderType {
  id
  pk
  pubId
  token
  created
  userEmail
  status
  isFullyPaid
  isNotPaid
  isShippingRequired
  isDelivered
  shippingMethodName
  groupLastUpdated
  userId
  giftCardData
  isGiftCard
  shippingCustomDiscount
  totalTax {
    currency
    gross
  }
  shippingDiscountAmount {
    currency
    gross
  }
  currency
  checkoutRate
}
    `;